<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('version.changelog.name')"
          type="text"
        />
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="machineSelectItems"
          v-model="item.machine"
          :items="machineSelectItems"
          :error-messages="machineErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('version.changelog.machine')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">

      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="toolheadSelectItems"
          v-model="item.toolhead"
          :items="toolheadSelectItems"
          :error-messages="toolheadErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('version.changelog.toolhead')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="materialsupplySelectItems"
          v-model="item.materialSupply"
          :items="materialsupplySelectItems"
          :error-messages="materialsupplyErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('version.changelog.materialsupply')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="controlunitSelectItems"
          v-model="item.controlUnit"
          :items="controlunitSelectItems"
          :error-messages="controlunitErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('version.changelog.controlunit')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="industrialcomputerSelectItems"
          v-model="item.industrialComputer"
          :items="industrialcomputerSelectItems"
          :error-messages="industrialcomputerErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('version.changelog.industrialcomputer')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="operatingsystemSelectItems"
          v-model="item.operatingSystem"
          :items="operatingsystemSelectItems"
          :error-messages="operatingsystemErrors"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('version.changelog.operatingsystem')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="printingsurfaceSelectItems"
          v-model="item.printingSurface"
          :items="printingsurfaceSelectItems"
          :error-messages="printingsurfaceErrors"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('version.changelog.printingsurface')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="accessorySelectItems"
          v-model="item.accessory"
          :items="accessorySelectItems"
          :error-messages="accessoryErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('version.changelog.accessory')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="softwareversionSelectItems"
          v-model="item.softwareVersion"
          :items="softwareversionSelectItems"
          :error-messages="softwareversionErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('version.changelog.softwareversion')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="optionSelectItems"
          v-model="item.option"
          :items="optionSelectItems"
          :error-messages="optionErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('version.changelog.option')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="userSelectItems"
          v-model="item.developer"
          :items="userSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('version.changelog.developer')"
          item-text="login"
          item-value="id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-radio-group v-model="item.developExternal" row :label="$t('version.changelog.developexternal')">
          <v-radio
            :label="$t('global.true')"
            value="true"
          ></v-radio>
          <v-radio
            :label="$t('global.false')"
            value="false"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row>
      <h3>{{ $t('version.changelog.start') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.start_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.start_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <h3>{{ $t('version.changelog.end') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.end_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.end_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import InputDate from '../InputDate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'ChangeLogFilter',
  components: {
    InputDate,
  },
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.machineGetSelectItems();
    this.toolheadGetSelectItems();
    this.materialsupplyGetSelectItems();
    this.controlunitGetSelectItems();
    this.industrialcomputerGetSelectItems();
    this.operatingsystemGetSelectItems();
    this.printingsurfaceGetSelectItems();
    this.accessoryGetSelectItems();
    this.optionGetSelectItems();
    this.softwareversionGetSelectItems();
    this.userGetSelectItems({'orderCol'  : 'order[login]','order'  : 'asc'});
  },

  computed: {
    ...mapFields('machine', {
      machineSelectItems: 'selectItems'
    }),
    ...mapFields('toolhead', {
      toolheadSelectItems: 'selectItems'
    }),
    ...mapFields('materialsupply', {
      materialsupplySelectItems: 'selectItems'
    }),
    ...mapFields('controlunit', {
      controlunitSelectItems: 'selectItems'
    }),
    ...mapFields('industrialcomputer', {
      industrialcomputerSelectItems: 'selectItems'
    }),
    ...mapFields('printingsurface', {
      printingsurfaceSelectItems: 'selectItems'
    }),
    ...mapFields('operatingsystem', {
      operatingsystemSelectItems: 'selectItems'
    }),
    ...mapFields('accessory', {
      accessorySelectItems: 'selectItems'
    }),
    ...mapFields('option', {
      optionSelectItems: 'selectItems'
    }),
    ...mapFields('softwareversion', {
      softwareversionSelectItems: 'selectItems'
    }),
    ...mapFields('user', {
      userSelectItems: 'selectItems'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      machineGetSelectItems: 'machine/fetchSelectItems'
    }),
    ...mapActions({
      toolheadGetSelectItems: 'toolhead/fetchSelectItems'
    }),
    ...mapActions({
      materialsupplyGetSelectItems: 'materialsupply/fetchSelectItems'
    }),
    ...mapActions({
      controlunitGetSelectItems: 'controlunit/fetchSelectItems'
    }),
    ...mapActions({
      industrialcomputerGetSelectItems: 'industrialcomputer/fetchSelectItems'
    }),
    ...mapActions({
      operatingsystemGetSelectItems: 'operatingsystem/fetchSelectItems'
    }),
    ...mapActions({
      printingsurfaceGetSelectItems: 'printingsurface/fetchSelectItems'
    }),
    ...mapActions({
      accessoryGetSelectItems: 'accessory/fetchSelectItems'
    }),
    ...mapActions({
      optionGetSelectItems: 'option/fetchSelectItems'
    }),
    ...mapActions({
      softwareversionGetSelectItems: 'softwareversion/fetchSelectItems'
    }),
    ...mapActions({
      userGetSelectItems: 'user/fetchSelectItems'
    }),
  }
};
</script>
